export default __webpack_public_path__ + "static/media/LGBTQ2_en.243688cb.svg";